import { useEffect } from 'react'
import React from 'react'
import Layout from '../Layout'

export default function faq(props) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <Layout props={props}>
            <div className="px-5 py-4 staticPgWrapper customContainer">
                {/* <h2>FAQs</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.terms,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
